'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _underscore = require('../utils/underscore');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIHoverlay = require('./UIHoverlay');

var _UIHoverlay2 = _interopRequireDefault(_UIHoverlay);

var _UIFlex = require('../layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UIAvatarHoverlay = _react2.default.createClass({
  displayName: 'UIAvatarHoverlay',

  propTypes: _extends({}, (0, _underscore.omit)(_UIHoverlay2.default.propTypes, 'use'), {
    I18n: _react.PropTypes.object,
    text: _react.PropTypes.node
  }),

  getClassName: function getClassName(_ref) {
    var className = _ref.className;

    return (0, _reactUtils.classNames)('private-avatar-hoverlay', 'display-inline-block', className);
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        I18n = _props.I18n,
        text = _props.text,
        rest = _objectWithoutProperties(_props, ['children', 'className', 'I18n', 'text']);

    return _react2.default.createElement(
      _UIHoverlay2.default,
      _extends({
        foregroundContent: _react2.default.createElement(
          _UIFlex2.default,
          { align: 'center', justify: 'center' },
          _react2.default.createElement(
            'div',
            { className: 'private-avatar-hoverlay__foreground-text' },
            text || I18n.text('salesUI.UIAvatarHoverlay.text')
          )
        )
      }, rest, {
        _blur: false,
        className: this.getClassName({ className: className })
      }),
      children
    );
  }
});

exports.default = (0, _Translatable2.default)(UIAvatarHoverlay);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/overlay/UIAvatarHoverlay.js
// module id = 281
// module chunks = 0